import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  MobileTermsOfService,
} from '../../components';
import config from '../../config';

import css from './MobileTermsOfServicePage.module.css';

const MobileTermsOfServicePageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const tabs = [
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.landownerReferralTitle' }),
      selected: false,
      linkProps: {
        name: 'LandownerReferralPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.AgritourismStatutesTitle' }),
      selected: false,
      linkProps: {
        name: 'AgritourismStatutesPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'TermsOfServicePage.MobileTermsOfServiceTitle' }),
      selected: true,
      linkProps: {
        name: 'MobileTermsOfServicePage',
      },
    },
  ];
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: '"MobileTermsOfServicePage.schemaTitle"' },
    { siteTitle }
  );
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="TermsOfServicePage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="MobileTermsOfServicePage.heading" />
            </h1>
            <MobileTermsOfService />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

MobileTermsOfServicePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const MobileTermsOfServicePage = compose(
  connect(mapStateToProps),
  injectIntl
)(MobileTermsOfServicePageComponent);

export default MobileTermsOfServicePage;
